import { IAppState } from '../../redux';
import { IPublishOption } from '../../redux/reducers';

export const selectActiveCalltrackingPeriod = (state: IAppState): IPublishOption | null => {
  const {
    calltracking: { periods, selectedPeriodId },
  } = state;

  if (typeof selectedPeriodId !== 'number') {
    return null;
  }

  return periods[selectedPeriodId] || null;
};
